module.exports = __webpack_public_path__ + "static/media/Akash.90402a10.png";